export const columns = [
  {
    icon: "ri-shield-check-line",
    title: "真假鉴定",
    desc: "把一条热门在线黑料逐句拆开，区分事实陈述与情绪判断，对照可靠信源给出可复核的结论。",
    tag: "单条甄别",
  },
  {
    icon: "ri-search-eye-line",
    title: "事实核查",
    desc: "围绕具体争议追踪时间线、原始出处与完整上下文，还原被截取、拼接甚至移花接木的片段。",
    tag: "追根溯源",
  },
  {
    icon: "ri-group-2-line",
    title: "多方求证",
    desc: "坚持让对立双方与第三方均发声，交叉比对多方说法，避免只取一面之词导致的误判。",
    tag: "交叉比对",
  },
  {
    icon: "ri-error-warning-line",
    title: "辟谣专区",
    desc: "集中收录已被证伪的流传黑料，标注澄清要点与辟谣时间，阻断重复转发的二次传播。",
    tag: "集中澄清",
  },
  {
    icon: "ri-file-list-3-line",
    title: "证据梳理",
    desc: "把截图、链接、时间戳与官方回应整理成可回溯的证据链，让每个结论都能翻到原始依据。",
    tag: "证据留档",
  },
  {
    icon: "ri-dashboard-3-line",
    title: "可信度分析",
    desc: "从信源权威性、证据完整度、动机与传播速度四个维度，量化给出可信度评分区间。",
    tag: "量化评分",
  },
];

export const processSteps = [
  {
    num: "01",
    title: "采集线索",
    desc: "接收读者投稿与巡查热门话题，记录原始文案、发布时间与最早可见出处。",
  },
  {
    num: "02",
    title: "信源分级",
    desc: "把线索中的信源按权威程度分级，剔除匿名与来源不明的说法，圈出可查证范围。",
  },
  {
    num: "03",
    title: "交叉核对",
    desc: "联系当事方与独立第三方，调取公开记录与一手资料，逐条对碰陈述之间的出入。",
  },
  {
    num: "04",
    title: "结论留档",
    desc: "按统一标准给出判断，同步公开证据链与核查日志，供读者再次检索复核。",
  },
];

export const criteria = [
  {
    title: "信源权威度",
    weight: "权重 40%",
    note: "优先采用官方公告、监管文件、原发机构与专业机构的一手信息。",
  },
  {
    title: "证据完整度",
    weight: "权重 30%",
    note: "要求能提供时间、地点、人物与上下文齐全的完整证据，而非单张截图。",
  },
  {
    title: "动机一致性",
    weight: "权重 20%",
    note: "评估传播者的立场与利益关系，警惕借热点博流量或恶意抹黑的内容。",
  },
  {
    title: "传播速度",
    weight: "权重 10%",
    note: "爆点型内容往往先情绪后证据，速度越快越需要冷静等待核实。",
  },
];